/**
 * Angular Imports
 */
import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
/**
 * services Imports
 */
import { AnalyticsEventService } from '../../analytics-event/analytics-event.service';
import { FunCollectionService } from '../../common/common-functions/fun-collection.service';
import { DataStorageService } from '../../dataservices/data-storage.service';
import { SurveyService } from '../../dataservices/survey/survey.service';
import { SurveyHelperService } from '../survey-helper.service';
import { MobileWebViewCommunicationService } from './../../dataservices/mobileWebViewCommunication/mobile-web-view-communication.service';
import { NewLanguageService } from './../../dataservices/new-language/new-language.service';

/**
 * constant Imports
 */
import { SURVEY_EVENT_NAME } from '../../analytics-event/survey-analytics.constant';
import {
  DEEPLINK_SURVEY,
  NUMBERS,
  PRODUCT_TYPE_CONSTANT,
  SCREEN_NAME,
  SURVEY_TAB_TYPE,
  WEBVIEW_MOBILE_METHOD_POST,
  WEBVIEW_MOBILE_PARAMS
} from '../../constants/app.constants';

import { AnalyticsInterface, EventDataKey } from '../../analytics-event/analytics.model';

/**
 * rxjs imports
 */
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { CountrySupportService } from 'src/app/dataservices/country-support/country-support.service';


@Component({
  selector: 'app-survey-card',
  templateUrl: './survey-card.component.html',
  styleUrls: ['./survey-card.component.scss']
})
export class SurveyCardComponent implements OnInit, OnDestroy {
  /**
   * To get survey product type
   */
  @Input() productType: string;

  /**
   * external survey or not
   */
  @Input() isPublicSource = false;
  /**
   * To get survey card data
   */
  @Input() surveyData;
  @Input() fileSignedUrls;
  @Input() activeTab;
  /**
   * For redirection on expire pop up
   */
  @Output() emitSwitchTab: EventEmitter<boolean> = new EventEmitter();
  /**
   * Save survey status object.
   */
  public surveyStatus = SURVEY_TAB_TYPE;
  /**
   * To store product.
   */
  public constantProductType = PRODUCT_TYPE_CONSTANT;
  /**
   * Analytics event.
   */
  public analyticsData: AnalyticsInterface;
  /**
   * Analytics event.
   */
  public viewDetailAnalytics: AnalyticsInterface;
  /**
   * To store survey listing screen name
   */
  public screenName: string;
  /**
   * To store survey listing screen analytics
   */
  public analyticsName = SURVEY_EVENT_NAME;
  /**
   * Flag to show specialty popup
   */
  public isPopup = false;
  /**
   * Flag to show more button for specialty
   */
  public isMoreTags = false;

  /**
   * Show/hide the expiry modal/
   */
  public isExpired = false;

  /**
   * notifier subject to close stream
   */
  private notifier$ = new Subject();

  /**
   * Necessary instances.
   */
  constructor(
    private dss: DataStorageService,
    private router: Router,
    private analyticsEventService: AnalyticsEventService,
    private mvc: MobileWebViewCommunicationService,
    private surveyHelper: SurveyHelperService,
    public surveyService: SurveyService,
    public fcs: FunCollectionService,
    public mls: NewLanguageService,
    public countrySupportService: CountrySupportService,
  ) { }
  /**
   * OnInit
   */
  ngOnInit(): void {
    if (this.productType === this.surveyStatus.ALL) {
      this.screenName = SCREEN_NAME.ALL_SURVEY_LISTING_SCREEN;
    } else if (this.productType === this.surveyStatus.DRAFT) {
      this.screenName = SCREEN_NAME.DRAFTS_SURVEY_LISTING_SCREEN;
    } else if (this.productType === this.surveyStatus.COMPLETED) {
      this.screenName = SCREEN_NAME.SURVEY_COMPLETE;
    }
    /**
     * Set analytics object for view detail click.
     */
    this.viewDetailAnalytics = {
      'event_name': this.analyticsName.VIEW_DETAILS_CLICK,
      'product_type': this.constantProductType.SURVEY,
      'product_type_id': this.surveyData.mi,
      'screen_name': this.screenName,
    };
  }
  /**
   * product Share
   */
  productShare(): void {
    this.sendAnalytics(this.analyticsName.SHARE_CLICK);
    const shareProduct = [{
      share_url: '',
      share_contentt: '',
      product_type: DEEPLINK_SURVEY.SURVEY,
      product_type_id: this.surveyData.code
    }];
    if (!this.mvc.checkAuthenticByPass()) {
      this.fcs.productShare(shareProduct);
    } else {
      this.surveyService.getShare(shareProduct[0].product_type, shareProduct[0].product_type_id).pipe(
        takeUntil(this.notifier$)).subscribe();
    }
  }

  /**
   * Function is used to get specialty.
   */
  getSpecialty(specialty): void {
    this.sendAnalytics(this.analyticsName.SURVEY_HASHTAG_CLICK);
    if (!this.mvc.checkAuthenticByPass()) {
      this.dss.specialty_filter = specialty;
      this.router.navigate(['/web/list']);
    } else {
      this.mvc.sendInfoToBothMobile({
        method: WEBVIEW_MOBILE_METHOD_POST, params: WEBVIEW_MOBILE_PARAMS.SURVEY_SPECIALITY_CLICK, body: {
          specialty_id: specialty.code,
          specialty_name: specialty.n,
          screen_name: SCREEN_NAME.ALL_SURVEY_LISTING_SCREEN,
          survey_id: this.surveyData.code
        }
      });
    }
  }
  /**
   * Function is used to navigate detail page
   */
  goToDetail(): void {
    this.dss.isSurveyFromListing = true;
    if((this.surveyData?.pty?.retkl !== 0) && this.productType === this.surveyStatus.COMPLETED){
      this.dss.isSurveyRetake = true;
    }
    if(!this.isPublicSource) {
      localStorage.setItem('surveyNumberId', this.surveyData.mi.toString());
      this.sendAnalytics(this.analyticsName.VIEW_DETAILS_CLICK);
    }
    if (!this.surveyHelper.checkForTheExpiry(this.surveyData.edms)) {
      this.setScrollViewData();
      if (this.screenName !== SCREEN_NAME.SURVEY_COMPLETE) {
        this.router.navigate(['/survey/detail/', this.surveyData.code]);
      }
      if (this.screenName === SCREEN_NAME.SURVEY_COMPLETE) {
        localStorage.setItem('surveyDetail', this.surveyData.code);
        this.router.navigate(['/survey/question', this.surveyData.code], { queryParams: { vm: true } });
      }
    } else {
      if (this.surveyData.pty.retkl !== NUMBERS.ZERO) {
        this.isExpired = true;
      } else {
        this.setScrollViewData();
        localStorage.setItem('surveyDetail', this.surveyData.code);
        this.router.navigate(['/survey/question', this.surveyData.code], { queryParams: { vm: true } });
      }
    }
  }
  /**
   * Function is used to navigate detail page
   */
  continueToSurvey(): void {
    this.sendAnalytics(this.analyticsName.CONTINUE_TO_SURVEY_CLICK);
    if (!this.surveyHelper.checkForTheExpiry(this.surveyData.edms)) {
      this.setScrollViewData();
      this.surveyService.getSurveyInfo(this.surveyData.code);
    } else {
      this.isExpired = true;
    }
  }
  /**
   * Function is used to open specialty popup
   */
  viewSpecialtyPopup(): void {
    this.isPopup = true;
  }
  /**
   * Function is used to close specialty popup
   */
  closeSpecialtyPopup(): void {
    this.isPopup = false;
  }
  /**
   * Function is used to navigate retake page
   */
  goToRetake(): void {
    this.dss.isSurveyRetake=true;
    if (!this.isPublicSource) {
      if (this.surveyData.pty.retkl !== NUMBERS.ZERO) {
        this.sendAnalytics(this.analyticsName.RETAKE_CLICK);
      } else{
        this.sendAnalytics(this.analyticsName.VIEW_DETAILS_CLICK);
      }
    }

    if (!this.surveyHelper.checkForTheExpiry(this.surveyData.edms)) {
      if (this.productType === this.surveyStatus.COMPLETED) {  console.log('1')
        localStorage.setItem('surveyDetail', this.surveyData.code);
        this.setIdLocalStorage();
        if (this.surveyData.pty.retkl === NUMBERS.ZERO) {  console.log('2')
          this.router.navigate(['/survey/question', this.surveyData.code], { queryParams: { vm: true } });
        } else {  console.log('3')
          this.setScrollViewData();
          this.surveyService.isRetake = true;
          this.surveyService.getSurveyInfo(this.surveyData.code);
        }
      }
    } else {
      if(this.surveyData.pty.retkl !== NUMBERS.ZERO) {  console.log('4')
        this.isExpired = true;
      } else {  console.log('5')
        localStorage.setItem('surveyDetail', this.surveyData.code);
        this.router.navigate(['/survey/question', this.surveyData.code], { queryParams: { vm: true } });
      }
    }
  }
  /**
   * Function is used to navigate channel detail page
   */
  channelDetail(channelCode: number): void {
    this.sendAnalytics(this.analyticsName.SPONSOR_CLICK);
    if(this.surveyData?.sn?.cid != 0 && this.surveyData?.sn?.cid){
      this.fcs.navigateToCommunityDetailPage(this.surveyData?.sn?.cid);
    } else if(this.fcs.navigateToSponsorDetail(channelCode, this.surveyData?.sn?.n)) {
      this.mvc.sendInfoToBothMobile({
        method: WEBVIEW_MOBILE_METHOD_POST,
        params: WEBVIEW_MOBILE_PARAMS.SPONSOR_REDIRECT,
        body: {
          ID: channelCode
        }
      });
      const deviceType = this.mvc.getAnalyticData()?.deviceType || null;
      if(!deviceType){
        this.fcs.navigateToChannelDetail(channelCode);
      }
    } else {
      const link = this.surveyHelper.extractHref(this.surveyData?.sn?.n);
      link && this.mvc.sendEventToIosApp({
        method: WEBVIEW_MOBILE_METHOD_POST,
        params: WEBVIEW_MOBILE_PARAMS.REDIRECT_CTA_CLICK,
        body: {
          link
        }
      });
    }
  }
  /**
   * Send analytics event.
   */
  sendAnalytics(eventName: EventDataKey): void {
    if (this.surveyService.isPublicSource || this.isPublicSource) {
      return;
    }
    this.analyticsEventService.sendAnalytics(eventName, this.constantProductType.SURVEY, this.surveyData.mi, this.screenName);
  }

  /**
   * close the expiry alert popup.
   */
  closeExpiryModal(): void {
    this.isExpired = false;
    this.emitSwitchTab.emit(true);
  }

  /**
   * set survey id to local storage
   */
  setIdLocalStorage(): void {
    const idToStore = (this.surveyData.mi).toString();
    localStorage.setItem('surveyNumberId', idToStore);
  }

  /**
   * set scroll data to local storage
   */
  setScrollViewData(): void {
    localStorage.setItem('scrollView', JSON.stringify({
      type: this.activeTab,
      sid: this.surveyData.code
    }));
  }

  /**
   * remove subscription and event listener
   */
  ngOnDestroy(): void {
    this.notifier$.next();
    this.notifier$.complete();
  }

  /**
   * sponsor click event
   */
  sponsorClicked(): void {
    this.sendAnalytics(SURVEY_EVENT_NAME.SPONSOR_CLICK);
  }

  /**
   * close the max pop up alert popup.
   */
  closeMaxRespondantModal(): void {
    this.surveyService.maxPopup = false;
  }
}
